var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入门店名称" },
            model: {
              value: _vm.listQuery.shopName,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "shopName", $$v)
              },
              expression: "listQuery.shopName"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "160px" },
            attrs: { clearable: "", placeholder: "请输入门店编号" },
            model: {
              value: _vm.listQuery.shopSn,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "shopSn", $$v)
              },
              expression: "listQuery.shopSn"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "160px" },
            attrs: { clearable: "", placeholder: "请输入归属经销商" },
            model: {
              value: _vm.listQuery.dealerName,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "dealerName", $$v)
              },
              expression: "listQuery.dealerName"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/shopEmail/list"],
                  expression: "['GET /admin/shopEmail/list']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("查找")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["POST /admin/shopEmail/create"],
                  expression: "['POST /admin/shopEmail/create']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v("添加")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "门店编号",
              prop: "shopNo",
              sortable: "",
              width: "140px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "门店名称", prop: "shopName" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "省",
              prop: "shopProvince",
              width: "100px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "城市",
              prop: "shopCity",
              width: "100px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "经销商",
              prop: "dealerName",
              width: "200px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "售后邮箱", prop: "email" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "抄送邮箱", prop: "emailCc" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "状态",
              prop: "deleted",
              width: "100px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.deleted == true
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("已停用")
                        ])
                      : _c("span", [_vm._v("正常")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              width: "250",
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/shopEmail/update"],
                            expression: "['POST /admin/shopEmail/update']"
                          }
                        ],
                        attrs: {
                          type: "text",
                          icon: "el-icon-edit",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/shopEmail/delete"],
                            expression: "['POST /admin/shopEmail/delete']"
                          }
                        ],
                        staticStyle: { color: "red" },
                        attrs: {
                          type: "text",
                          icon: "el-icon-close",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "860px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店名称", prop: "shopName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入门店名称" },
                    model: {
                      value: _vm.dataForm.shopName,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "shopName", $$v)
                      },
                      expression: "dataForm.shopName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店编号", prop: "shopNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入DRM的门店编号" },
                    model: {
                      value: _vm.dataForm.shopNo,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "shopNo", $$v)
                      },
                      expression: "dataForm.shopNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属渠道", prop: "channel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择所属渠道" },
                      model: {
                        value: _vm.dataForm.channel,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "channel", $$v)
                        },
                        expression: "dataForm.channel"
                      }
                    },
                    _vm._l(_vm.channels, function(type) {
                      return _c("el-option", {
                        key: type.name,
                        attrs: { label: type.name, value: type.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "售后邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "请输入门店售后联系邮箱 多个以,隔开（注意半角）"
                    },
                    model: {
                      value: _vm.dataForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "email", $$v)
                      },
                      expression: "dataForm.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "抄送邮箱", prop: "emailCc" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入门店抄送邮箱 多个以,隔开（注意半角）"
                    },
                    model: {
                      value: _vm.dataForm.emailCc,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "emailCc", $$v)
                      },
                      expression: "dataForm.emailCc"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "deleted" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择状态" },
                      model: {
                        value: _vm.dataForm.deleted,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "deleted", $$v)
                        },
                        expression: "dataForm.deleted"
                      }
                    },
                    _vm._l(_vm.deletedOptions, function(type) {
                      return _c("el-option", {
                        key: type.value,
                        attrs: { label: type.label, value: type.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData }
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }